import React, { Component, useRef, useState, useEffect } from 'react';
import { useHistory, useLocation, NavLink } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import { CountryList, OMCList } from '@C/Utils';
import { authHeader } from '@H';
import axios from 'axios';
import { toast } from 'react-toastify';
import OtpInput from 'react-otp-input';
import { set } from 'lodash';

const Registration = () => {
  const history = useHistory();
  const location = useLocation();
  const [pastData] = useState(location.state?.formData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpGenerated, setOtpGenerated] = useState(false);
  const [, forceUpdate] = useState();
  const structureId = location.state?.structure_id || '';
  const planName = location.state?.plan_name || '';

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        customEmail: {
          message:
            'The email must be valid and not start with dots or consecutive dots.',
          rule: (val) =>
            /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
              val,
            ),
          required: true,
        },
      },
    }),
  );
  const ccRef = useRef(null);

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirm_password: '',
    email: '',
    otp: '',
    mobile: '',
    user_role: 101,
    first_name: '',
    last_name: '',
    subscription: {
      plan_code: 202,
      subscription_structure_code: 400,
      subscription_plan_id: structureId,
      bunk: {
        ro_name: '',
        omc_uuid: '',
        gst_no: null,
        address: {
          city: '',
          state: '',
          country: '',
          pincode: null,
          country_code: '',
          std_code: '',
        },
      },
    },
  });

  useEffect(() => {
    if (pastData) {
      setFormData(pastData);
    }
  }, [pastData]);

  const onTogglePasswd = () => {
    setShowPassword(!showPassword);
  };

  const onToggleConfirmPasswd = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleBunkChange = (e) => {
    const subscription = { ...formData.subscription };
    subscription.bunk[e.target.name] = e.target.value;
    setFormData({ ...formData, subscription });
  };

  const handleOMCChange = (e) => {
    const subscription = { ...formData.subscription };
    subscription.bunk.omc_uuid = e;
    setFormData({ ...formData, subscription });
  };

  const handleCountrySelect = (e) => {
    const subscription = { ...formData.subscription };
    subscription.bunk.address.country = e?.value;
    subscription.bunk.address.std_code = e?.stdCode || '';
    setFormData({ ...formData, subscription });
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      subscription: {
        ...prevFormData.subscription,
        bunk: {
          ...prevFormData.subscription.bunk,
          address: {
            ...prevFormData.subscription.bunk.address,
            [name]: value,
          },
        },
      },
    }));
  };

  const generateOTP = (e) => {
    e.preventDefault();
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }

    setLoading(true);
    setOtpGenerated(true);
    setLoading(false);
  };

  return otpGenerated ? (
    <TwoStepAuth
      formData={formData}
      planName={planName}
      previousStep={() => setOtpGenerated(false)}
    />
  ) : (
    <div className="registration-container">
      <h1>Registration</h1>
      <form className="full-width">
        <div className="input-wrapper">
          <label> Company name</label>
          {simpleValidator.current.message(
            'bunk name',
            formData.subscription.bunk.ro_name,
            'required',
          )}
          <input
            type="text"
            onChange={handleBunkChange}
            value={formData.subscription.bunk.ro_name}
            name="ro_name"
          />
        </div>
        <div className="input-wrapper">
          <label> Owner Name </label>
          {simpleValidator.current.message(
            'first name',
            formData.first_name,
            'required',
          )}
          <input
            type="text"
            onChange={handleChange}
            value={formData.first_name}
            name="first_name"
          />
        </div>
        <div className="input-wrapper">
          <label>OMC</label>
          {simpleValidator.current.message(
            'omc',
            formData.subscription.bunk.omc_uuid,
            'required',
          )}
          <OMCList
            handleOMCChange={handleOMCChange}
            value={formData.subscription.bunk.omc_uuid}
          />
        </div>
        <div className="input-wrapper">
          <label> Email</label>
          {simpleValidator.current.message(
            'email',
            formData.email,
            'required|customEmail',
          )}
          <input
            type="email"
            onChange={handleChange}
            value={formData.email}
            name="email"
          />
        </div>
        <div
          className={showPassword ? 'input-wrapper visible' : 'input-wrapper'}
        >
          <label>Password</label>
          {simpleValidator.current.message(
            'password',
            formData.password,
            'required',
          )}
          <input
            type={showPassword ? 'text' : 'password'}
            onChange={handleChange}
            value={formData.password}
            name="password"
          />
          <span className="show-psswd" onClick={onTogglePasswd} />
        </div>
        <div
          className={
            showConfirmPassword ? 'input-wrapper visible' : 'input-wrapper'
          }
        >
          <label>Confirm Password</label>
          {simpleValidator.current.message(
            'confirm password',
            formData.confirm_password,
            'required|in:' + formData.password,
          )}
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            onChange={handleChange}
            value={formData.confirm_password}
            name="confirm_password"
          />
          <span className="show-psswd" onClick={onToggleConfirmPasswd} />
        </div>
        <div className="input-wrapper">
          <label>Country</label>
          {simpleValidator.current.message(
            'country',
            formData.subscription.bunk.address.country,
            'required',
          )}
          <CountryList
            handleCountryChange={handleCountrySelect}
            value={formData.subscription.bunk.address.country}
            code={formData.subscription.bunk.address.country_code}
          />
        </div>
        <div className="input-wrapper">
          <label>Region</label>
          {simpleValidator.current.message(
            'state',
            formData.subscription.bunk.address.state,
            'required',
          )}
          <input
            type="text"
            onChange={handleAddressChange}
            value={formData.subscription.bunk.address.state}
            name="state"
          />
        </div>
        <div className="input-wrapper">
          <label>City</label>
          {simpleValidator.current.message(
            'city',
            formData.subscription.bunk.address.city,
            'required',
          )}
          <input
            type="text"
            onChange={handleAddressChange}
            value={formData.subscription.bunk.address.city}
            name="city"
          />
        </div>
        <div className="input-wrapper">
          <label>Mobile</label>
          {simpleValidator.current.message(
            'mobile',
            formData.mobile,
            'required|numeric|min:10,array|max:10,array',
          )}
          <div className="mobile-input-wrapper">
            <input
              className="small-input"
              type="text"
              value={formData.subscription.bunk.address.std_code}
              name="std_code"
              disabled
            />
            <input
              type="number"
              className="large-input"
              onChange={handleChange}
              value={formData.mobile}
              name="mobile"
            />
          </div>
        </div>
        {/* <div className={loading ? 'input-wrapper loading' : 'input-wrapper'}>
          <label>Area Code</label>
          {simpleValidator.current.message(
            'pincode',
            formData.subscription.bunk.address.pincode,
            'numeric',
          )}
          <input
            type="text"
            onChange={handleAddressChange}
            value={formData.subscription.bunk.address.pincode}
            name="pincode"
          />
        </div> */}

        <div className="cta-wrapper">
          <NavLink to="/subscription" className="submit invert">
            Back
          </NavLink>
          <button className="submit" onClick={(e) => generateOTP(e)}>
            Continue
          </button>
        </div>
      </form>
    </div>
  );
};

const TwoStepAuth = (props) => {
  const [otp, setOtp] = useState('');
  const [timer, setTimer] = useState(6);
  const formData = props.formData;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const planName = props.planName;

  useEffect(() => {
    generateOTP();
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 0) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const generateOTP = (e) => {
    e && e.preventDefault();
    setLoading(true);
    const email = formData.email;
    const from_app = 'ACCOUNT';
    const headers = authHeader(1);
    axios
      .post(
        `${process.env.API_URL}/two-step-auth/`,
        {
          from_app,
          email,
        },
        { headers },
      )
      .then((response) => {
        setLoading(false);
        setTimer(60);
      })
      .catch((error) => {
        setLoading(false);
        props.previousStep();
        console.error('Error sending OTP:', error);
        toast.error('Error generating OTP');
      });
  };

  const verifyOTP = (e) => {
    e.preventDefault();
    if (!otp) {
      toast.error('Please enter OTP');
      return;
    }

    setLoading(true);
    setIsSubmitting(true);
    const headers = authHeader(1);

    axios
      .get(`${process.env.API_URL}/users/validate-user-otp/?otp=${otp}`, null, {
        headers,
      })
      .then((response) => {
        setLoading(false);
        toast.success(response.data.message);
        setIsSubmitting(false);
        submitForm();
        setLoading(false);

        // history.push('/auh/login');
      })
      .catch((error) => {
        console.error('Error verifying OTP:', error);
        setIsSubmitting(false);
        toast.error(error.response.data.message);
      });
  };

  const submitForm = () => {
    const headers = authHeader();
    formData.otp = otp;

    axios
      .post(`${process.env.API_URL}/users/register/`, formData, { headers })
      .then((response) => {
        if (response.status !== 201) {
          toast.error(response.data.message, {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return;
        } else {
          if (planName === 'TRIAL') {
            toast.success(
              'Account created successfully. Redirecting to login page',
            );
            setTimeout(() => {
              history.push('/login');
            }, 3000);
            return;
          }
          toast.success(
            'Account created successfully. Redirecting to payment page',
          );
          axios
            .post(`${process.env.API_URL}/payment/gate-way/`, {
              bunk_id: response.data.data[0].bunk_id,
              subscription_id: response.data.data[0].subscription_id,
            })
            .then((response) => {
              window.location = response.data.data.redirect_url;
            });
          // .catch((err) => {
          //   toast.error(
          //     'Error redirecting to payment page. Please complete payment from account page after login',
          //   );
          //   setTimeout(() => {
          //     history.push('/login');
          //   }, 5000);
          // });
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  return (
    <div className="otp-container">
      <form className="otp-form">
        <div className="otp-header">
          <h4>Check your email</h4>
          <p>Please enter the six digit verification code we sent to</p>
          <p>{formData.email}</p>
        </div>
        <div className="input-wrapper otp-input">
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span>-</span>}
            inputStyle={{
              width: '3rem',
              height: '3rem',
              margin: '0 0.5rem',
              fontSize: '2rem',
              borderRadius: '5px',
              border: '1px solid #ced4da',
            }}
            renderInput={(props) => <input {...props} />}
          />
        </div>
        <div className="cta-wrapper">
          <button
            className={`submit ${isSubmitting ? 'loading' : ''}`}
            onClick={(e) => verifyOTP(e)}
          >
            Confirm
          </button>
        </div>
        <div className="otp-footer">
          <span>Didn't receive the code? </span>
          {timer === 0 ? (
            <button className="resend-otp" onClick={(e) => generateOTP(e)}>
              Resend OTP
            </button>
          ) : (
            <span>Resend in {timer} sec</span>
          )}
          <p>
            Not your email address?{' '}
            <button className="link link-back" onClick={props.previousStep}>
              Go back
            </button>
          </p>
        </div>
      </form>
    </div>
  );
};

export { Registration };
